import { mapGetters, mapMutations, mapActions } from 'vuex';
import mvtNewMap, { pinType } from '@/common/components/mvtnewmap/mvt-newmap.vue';
import mvtCardProperty from '@/common/components/mvtcardproperty/mvt-cardproperty.vue';

import mapper from '../../../common/store/mapper/index.js';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';

function getPropertyList(arr, state) {
    if (arr && arr.length) {
        return arr.map(function (e) {
            return mapper.property(e, state);
        });
    }
    return [];
}
export default {
    name: 'brokerageNearby',
    inject: ['$eventBus'],
    props: {
        geo: {
            type: Object,
            default: function () {
                return null;
            },
        },
        agentId: {
            type: String,
            default: '',
        },
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dap', ['dap']),
        getCityPathForFilters() {
            if (!this.geo.cityPath) {
                return '';
            }
            return this.geo.cityPath.replace('homes-for-sale/', '');
        },
        getListings() {
            if (this.tabIndex == 0) {
                return this.listingsForSale || [];
            }
            return this.listingsForSold || [];
        },

        hideView() {
            return this.agentId && this.isMapLoaded && !this.listingsForSold.length;
        },
        filteredListings() {
            return this.getListings.filter((listing) => listing.geo && listing.geo.lat && listing.geo.lng);
        },
    },
    data() {
        return {
            isMapLoaded: false,
            tabIndex: 1,
            listingsForSale: [],
            listingsForSold: [],
            loadForSale: false,
            loadForSold: false,
        };
    },
    components: {
        mvtNewMap,
        mvtCardProperty,
    },
    methods: {
        ...mapActions('glb', ['getHousesBySearchUrl']),
        ...mapActions('dap', ['fetchHouseByAgentId']),
        ...mapMutations('glb', ['setNearbySold', 'setNearbySale']),
        onMarkerSelected(data) {
            let el = this.$refs.list.querySelector(`[data-id="${data[0].propertyId}"]`);
            el && el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        },
        onTabChange(index) {
            const that = this;
            this.tabIndex = index;
            if (this.geo) {
                let latLng = this.geo.cityCode === 'san-francisco' ? `@${+this.geo.lat + 1.4},${+this.geo.lng + 1.4},${+this.geo.lat - 1.4},${+this.geo.lng - 1.4},9` : '';
                if (index === 0 && !this.loadForSale) {
                    this.loadForSale = true;
                    this.getHousesBySearchUrl({
                        path: `${this.getCityPathForFilters}listedbymovoto/${latLng}`,
                    }).then(function (e) {
                        that.listingsForSale = e.listings ? getPropertyList(e.listings, that.glb) : [];
                        if (that.listingsForSale.length === 0 && that.loadForSold === false) {
                            that.onTabChange(1);
                        }
                    });
                } else if (index === 1 && !this.loadForSold) {
                    this.loadForSold = true;
                    this.getHousesBySearchUrl({
                        path: `${this.getCityPathForFilters}listedbymovoto/sold/${latLng}`,
                    }).then(function (e) {
                        that.listingsForSold = e.listings ? getPropertyList(e.listings, that.glb) : [];
                        if (that.listingsForSold.length === 0 && that.loadForSale === false) {
                            that.onTabChange(0);
                        }
                    });
                }
            }
        },
        loadTransactionListing() {
            const that = this;
            const index = this.tabIndex;
            if (index === 0 && !this.loadForSale) {
                this.loadForSale = true;
                this.fetchHouseByAgentId(this.agentId).then(function (e) {
                    that.listingsForSale = e.listings ? getPropertyList(e.listings, that.glb) : [];
                });
            } else if (index === 1 && !this.loadForSold) {
                this.loadForSold = true;
                this.fetchHouseByAgentId(this.agentId).then(function (e) {
                    that.listingsForSold = e.data ? getPropertyList(e.data, that.glb) : [];
                    that.isMapLoaded = true;
                });
            }
        },
        initalMap() {
            if (this.agentId) {
                this.loadTransactionListing();
            } else {
                this.onTabChange(this.tabIndex);
            }
        },
        onMapReady() {
            let that = this;
            const $list = $(this.$refs.list);
            $list.on(
                'mouseenter',
                '.mvt-cardproperty',
                throttle(function () {
                    const $this = $(this);
                    const hoverMarkId = $this.data('id');
                    let data = that.filteredListings.find((e) => e.propertyId === hoverMarkId);
                    if (data) {
                        that.$refs.map?.hoverMarker(pinType.property, data.geo.lat, data.geo.lng);
                        that.$refs.mapRef?.panTo(data.geo.lat, data.geo.lng);
                    } else {
                        that.$refs.map?.unhoverMarker();
                    }
                }, 20)
            );
        },
    },
    mounted() {
        this.initalMap();
    },
};
